import type { Plan } from "../models";
import type { Quota, SystemFeatureCode } from "../models";
import { UNLIMITED_QUOTA } from "../models";
import type { PlanTemplate } from "../types";

const now = () => new Date().toISOString();

export const PLAN_TRIAL_ID = "plan-trial";
export const PLAN_STARTER_ID = "plan-starter";
export const PLAN_BUSINESS_ID = "plan-business";
export const PLAN_ENTERPRISE_ID = "plan-enterprise";

const ALL_FEATURES: SystemFeatureCode[] = [
  "hr",
  "organization",
  "leave",
  "attendance",
  "schedule",
  "performance",
  "compensation",
  "training",
  "career",
  "payroll",
  "recruitment",
  "crm",
  "tickets",
  "itsm",
  "problems",
  "changes",
  "projects",
  "knowledge",
  "contracts",
  "billing",
  "service_catalog",
  "assets",
  "inventory",
  "hospitol",
  "mineportal",
  "subportal",
  "edu",
  "security",
  "analytics",
  "api",
  "identity",
  "reports",
  "customer_portal",
  "service_requests",
  "approvals",
  "automation",
];

export const PLAN_TEMPLATES: PlanTemplate[] = [
  {
    plan: {
      id: PLAN_TRIAL_ID,
      code: "trial",
      name: "Trial",
      description: "Essai gratuit 14 jours",
      monthlyPrice: 0,
      yearlyPrice: 0,
      trialDays: 14,
      isActive: true,
      createdAt: now(),
      updatedAt: now(),
    },
    defaultQuotas: {
      users: 5,
      employees: 25,
      storageGb: 25,
      apiCallsPerMonth: 1000,
    },
    defaultFeatures: ["hr", "crm", "tickets"],
  },
  {
    plan: {
      id: PLAN_STARTER_ID,
      code: "starter",
      name: "Starter",
      description: "Petites équipes",
      monthlyPrice: 49,
      yearlyPrice: 470,
      trialDays: 0,
      isActive: true,
      createdAt: now(),
      updatedAt: now(),
    },
    defaultQuotas: {
      users: 10,
      employees: 50,
      storageGb: 50,
      apiCallsPerMonth: 5000,
    },
    defaultFeatures: ["hr", "organization", "leave", "attendance", "crm", "tickets", "assets", "security", "knowledge", "service_catalog", "customer_portal", "service_requests"],
  },
  {
    plan: {
      id: PLAN_BUSINESS_ID,
      code: "business",
      name: "Business",
      description: "Suite RH complète PME",
      monthlyPrice: 149,
      yearlyPrice: 1430,
      trialDays: 14,
      isActive: true,
      createdAt: now(),
      updatedAt: now(),
    },
    defaultQuotas: {
      users: 50,
      employees: 250,
      storageGb: 100,
      apiCallsPerMonth: 25000,
    },
    defaultFeatures: ["hr", "crm", "tickets", "payroll", "recruitment", "organization", "leave", "attendance", "schedule", "performance", "compensation", "training", "career", "assets", "security", "itsm", "knowledge", "problems", "changes", "contracts", "service_catalog", "customer_portal", "service_requests", "approvals"],
  },
  {
    plan: {
      id: PLAN_ENTERPRISE_ID,
      code: "enterprise",
      name: "Enterprise",
      description: "Illimité — tous les modules",
      monthlyPrice: 399,
      yearlyPrice: 3830,
      trialDays: 0,
      isActive: true,
      createdAt: now(),
      updatedAt: now(),
    },
    defaultQuotas: {
      users: UNLIMITED_QUOTA,
      employees: UNLIMITED_QUOTA,
      storageGb: UNLIMITED_QUOTA,
      apiCallsPerMonth: UNLIMITED_QUOTA,
    },
    defaultFeatures: ALL_FEATURES,
  },
];

export const SEED_PLANS: Plan[] = PLAN_TEMPLATES.map((t) => t.plan);

export function getPlanTemplateById(planId: string): PlanTemplate | undefined {
  return PLAN_TEMPLATES.find((t) => t.plan.id === planId);
}

export function getPlanTemplateByCode(code: string): PlanTemplate | undefined {
  return PLAN_TEMPLATES.find((t) => t.plan.code === code);
}
